<svg xmlns="http://www.w3.org/2000/svg" width="394" height="394" viewBox="0 0 394 394">
   <g id="Group_78" data-name="Group 78" transform="translate(-990 -637)">
      <rect
         id="Rectangle_7"
         data-name="Rectangle 7"
         width="394"
         height="394"
         transform="translate(990 637)"
         fill="none"
      />
      <g id="bar_2_" data-name="bar (2)" transform="translate(990 752.368)">
         <g id="Group_72" data-name="Group 72" transform="translate(0 -0.368)">
            <g id="Group_71" data-name="Group 71">
               <g id="Group_70" data-name="Group 70">
                  <g id="Group_63" data-name="Group 63" transform="translate(0 206.64)">
                     <g id="Group_62" data-name="Group 62">
                        <line
                           id="Line_11"
                           data-name="Line 11"
                           x2="394"
                           transform="translate(0 0.36)"
                           fill="none"
                           stroke="#ddd"
                           stroke-width="3"
                        />
                     </g>
                  </g>
                  <g id="Group_65" data-name="Group 65" transform="translate(0 137.833)">
                     <g id="Group_64" data-name="Group 64">
                        <line id="Line_12" data-name="Line 12" x2="394" fill="none" stroke="#ddd" stroke-width="3" />
                     </g>
                  </g>
                  <g id="Group_67" data-name="Group 67" transform="translate(0 69.025)">
                     <g id="Group_66" data-name="Group 66">
                        <line id="Line_13" data-name="Line 13" x2="394" fill="none" stroke="#ddd" stroke-width="3" />
                     </g>
                  </g>
                  <g id="Group_69" data-name="Group 69">
                     <g id="Group_68" data-name="Group 68">
                        <line
                           id="Line_14"
                           data-name="Line 14"
                           x2="394"
                           transform="translate(0 0)"
                           fill="none"
                           stroke="#ddd"
                           stroke-width="3"
                        />
                     </g>
                  </g>
               </g>
            </g>
         </g>
         <g id="Group_77" data-name="Group 77" transform="translate(0 -0.151)">
            <g id="Group_76" data-name="Group 76">
               <g id="Group_73" data-name="Group 73" transform="translate(0 137.615)">
                  <path
                     id="Path_7"
                     data-name="Path 7"
                     d="M4.487,153.333H122.059a4.487,4.487,0,0,1,4.487,4.487v63.722H0V157.82a4.487,4.487,0,0,1,4.487-4.487Z"
                     transform="translate(0 -153.333)"
                     fill="#b1c4e2"
                  />
               </g>
               <g id="Group_74" data-name="Group 74" transform="translate(133.727)">
                  <path
                     id="Path_8"
                     data-name="Path 8"
                     d="M153.487,0H271.059a4.487,4.487,0,0,1,4.487,4.487V206.424H149V4.487A4.487,4.487,0,0,1,153.487,0Z"
                     transform="translate(-149)"
                     fill="#6b9ad2"
                  />
               </g>
               <g id="Group_75" data-name="Group 75" transform="translate(267.453 68.808)">
                  <path
                     id="Path_9"
                     data-name="Path 9"
                     d="M302.487,76.667H420.059a4.487,4.487,0,0,1,4.487,4.487V213.983H298V81.154a4.488,4.488,0,0,1,4.487-4.487Z"
                     transform="translate(-298 -76.667)"
                     fill="#597dad"
                  />
               </g>
            </g>
         </g>
      </g>
   </g>
</svg>
